<template lang="html">
  <StandardCard
    :image="project_member.image !== 'noimage'? project_member.image:'https://cdn.pixabay.com/photo/2014/05/02/23/46/new-york-city-336475_1280.jpg'"
    :name="project_member.first_name + ' ' + project_member.last_name"
    >
    <template #info>
      <v-list two-line>
        <v-list-item>
          <v-list-item-action>
            <v-icon color="blue">assignment_ind</v-icon>
          </v-list-item-action>
          <v-list-item-content>
            <v-list-item-title v-if="!edit_role">{{project_member.prole.name}}</v-list-item-title>
            <v-list-item-title v-if="edit_role">
              <StandardDropdown
                class="ma-0"
                header="Select Role:"
                :value="change_prole.name"
                @changeValue="change_prole = $event"
                placeholder="Project Roles"
                :options="project_roles"
              />
            </v-list-item-title>
            <v-list-item-subtitle>
              {{$t('Project.Settings.Members.Members.ProjectRole')}}
              <v-btn v-if="hasProjectPermission({
                      project_id: $route.params.project_id,
                      ppermission: 'Update User Role'
                    })  && !edit_role"
                    icon
                    color="green"
                    class="pull-right"
                    @click="edit_role = true"
                    >
                    <v-icon>edit</v-icon>
              </v-btn>
              <v-btn v-if="hasProjectPermission({
                      project_id: $route.params.project_id,
                      ppermission: 'Update User Role'
                    }) && edit_role"
                    icon
                    color="red"
                    class="pull-right"
                    @click="edit_role = false"
                    >
                    <v-icon>cancel</v-icon>
              </v-btn>
              <v-btn v-if="hasProjectPermission({
                      project_id: $route.params.project_id,
                      ppermission: 'Update User Role'
                    })  && edit_role"
                    icon
                    color="green"
                    class="pull-right"
                    @click="updateUserRole(project_member.id)"
                    >
                    <v-icon>done</v-icon>
              </v-btn>
            </v-list-item-subtitle>
          </v-list-item-content>
        </v-list-item>
        <v-list-item>
          <v-list-item-action>
            <v-icon color="blue">phone</v-icon>
          </v-list-item-action>
          <v-list-item-content>
            <v-list-item-title>{{project_member.phone_number}}</v-list-item-title>
            <v-list-item-subtitle>{{$t('Project.Settings.Members.Members.PhoneNumber')}}</v-list-item-subtitle>
          </v-list-item-content>
        </v-list-item>
        <v-list-item>
          <v-list-item-action>
            <v-icon color="blue">mail</v-icon>
          </v-list-item-action>
          <v-list-item-content>
            <v-list-item-title>{{project_member.email}}</v-list-item-title>
            <v-list-item-subtitle>{{$t('Project.Settings.Members.Members.Email')}}</v-list-item-subtitle>
          </v-list-item-content>
        </v-list-item>
        <v-list-item>
          <v-list-item-action>
            <v-icon color="blue">dns</v-icon>
          </v-list-item-action>
          <v-list-item-content>
            <div class="wp-list">
              <TWorkPackage
                v-for="wp in project_member.work_packages"
                :key="`selectedwp${wp.id}`"
                :workpackage_count="1"
                :workpackage="wp"
                :color="wp.color"
              >
              <template #workpackage>
                <StandardBadge
                  class="cursor-pointer"
                  :text="wp.count"
                  color="white"
                  content_color="black"
                />
                </template>
              </TWorkPackage>
              <v-btn
              v-if="hasProjectPermission({
                      project_id: $route.params.project_id,
                      ppermission: 'Add User Work Packages'
                    })"
              icon
              @click="$router.push({
                  name: 'ProjectInviteWPSelectTaktPlan',
                  params: {
                    project_id: $route.params.project_id,
                    edit_member: true,
                    user_id: project_member.id,
                  }
                })"
              ><v-icon>edit</v-icon></v-btn>
            </div>
          </v-list-item-content>
        </v-list-item>
        <v-list-item
          v-if="hasProjectPermission({
                  project_id: $route.params.project_id,
                  ppermission: 'Remove User'
                }) &&
                getUser.id !== project_member.id"
          class="list-item-bg">
          <v-list-item-action>
            <v-icon color="snow">cancel</v-icon>
          </v-list-item-action>
          <v-list-item-content v-if="!show_delete">
            <v-btn @click="show_delete=true" text>{{$t('Project.Settings.Members.Members.RemoveMember')}} {{ project_member.first_name + ' ' + project_member.last_name }}</v-btn>
          </v-list-item-content>
          <v-list-item-content v-else>
            <v-btn @click="removeUsersFromProject({
                project_id: $route.params.project_id,
                users: [{
                    id: project_member.id,
                    prole: project_member.prole.id
                  }]
              })" text>{{$t('Project.Settings.Members.Members.ClickAgainRemove')}} {{project_member.first_name + ' ' + project_member.last_name}}</v-btn>
          </v-list-item-content>
        </v-list-item>
      </v-list>
    </template>
  </StandardCard>
</template>

<script>
import { TWorkPackageMixin } from '@/mixins/TWorkPackage.mixin.js'
import StandardCard from '@/components/StandardComponents/StandardCard.component.vue'
import StandardDropdown from '@/components/StandardComponents/StandardDropdown.component.vue'
import StandardBadge from '@/components/StandardComponents/StandardBadge.component.vue'
import {
  mapGetters, mapActions
} from 'vuex';
export default {
  components: {
    StandardCard,
    StandardBadge,
    StandardDropdown
  },
  mixins: [TWorkPackageMixin],
  props: ['project_member', 'project_id'],
  data: function () {
    return {
      show_delete: false,
      edit_role: false,
      project_roles: [],
      change_prole: {
        prole: 0
      }
    }
  },
  created(){
    // this.project_roles = this.getProjectProles(this.project_id);
    this.project_roles = this.getUObjects({type: 'proles', ids: this.getUObject({type: 'projects', id: this.project_id}).proles});
    this.change_prole.name = this.project_member.prole.name;
  },
  computed: {
    ...mapGetters('View', [
      'getProjectMembersSelectedIndex'
    ]),
    ...mapGetters('Auth', [
      'getUser',
    ]),
    ...mapGetters('Ultra', [
      'getUObject',
      'getUObjects',
    ]),
    ...mapGetters('Project', [
      'hasProjectPermission',
      'getProjectProles'
    ]),
  },
  watch: {
    getProjectMembersSelectedIndex: function () {
      this.show_delete = false;
      this.edit_role = false;
    }
  },
  methods: {
    ...mapActions('ProjectMember', [
      'removeUsersFromProject',
      'changeUserProjectRole'
    ]),
    updateUserRole(user_id){
      this.changeUserProjectRole({
        project_id: this.project_id,
        change: {
          user: user_id,
          prole: this.change_prole.id
        }
      });
      this.edit_role = false;
    }
  }
}
</script>

<style lang="css" scoped>
.list-item-bg {
  background-color: red;
}
.wp-list{
  display: flex;
  overflow-x: auto;
  overflow-y: visible;
}
</style>
